import { State } from '../Store';

export const selectRoles = (state: State) => state.roles;
